// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Cofre_UpdateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Input contract for PUT /cofre/:id (update).
 */
import { registerContract } from './validate'

export interface Cofre_UpdateInput {
nome?: string
banco?: string
agencia?: string
conta?: string
tipo?: string
saldo_atual?: number
observacao?: string
}

registerContract('Cofre_UpdateInput', {
  nome:        { type: 'string',  required: false },
  banco:       { type: 'string',  required: false },
  agencia:     { type: 'string',  required: false },
  conta:       { type: 'string',  required: false },
  tipo:        { type: 'string',  required: false },
  saldo_atual: { type: 'number',  required: false },
  observacao:  { type: 'string',  required: false },
})
